import axios  from "axios"
import { req } from "./axiosFun"

export const patientlist = (params) => {return req('get','/api/index/patientList',params)}
export const departmentlist = (params) => {return req('get','/api/index/departmentlist',params)}
export const doctorlist = (params) => {return req('get','/api/index/doctorlist',params)}
export const deptInfo = (params) => {return req('post','/api/index/deptInfo',params)}
export const doctorInfo = (params) => {return req('post','/api/index/doctorInfo',params)}
export const registrationList = (params) => {return req('get','/api/index/registrationList',params)}
export const indexshow = (params) => {return req('get','/api/index/index',params)}
export const zhuanjialist = (params) => {return req('get','/api/index/zhuanjialist',params)}
export const zhuanjiaInfo = (params) => {return req('post','/api/index/zhuanjiaInfo',params)}
export const getdepartment = (params) => {return req('get','/api/department/getdepartment',params)} //获取科室列表
export const updatedepartment = (params) => {return req('get','/api/department/updatedepartment',params)}


// 新闻接口
export const addNews = (params) => { return req('post','/api/news/addNews',params)}
export const updateNews = (params) => { return req('post','/api/news/updateNews',params)}
export const delNews = (params) => { return req('get','/api/news/delNews',params)}
export const newsList = (params) => { return req('get','/api/news/newsList',params)}
export const getArticle = (params) => { return req('get','/api/news/article',params)}
export const newsType = (params) => { return req('get','/api/news/newsType',params)}

// 日志接口
export const logList = (params) => { return req('get','/api/system/logList',params)}
export const delLog = (params) => { return req('post','/api/system/delLog',params)}

// 用户管理
export const userList = (params) => { return req("get", "/api/system/userList", params) }
export const userSave = (params) => { return req("post", "/api/system/userSave", params) }
export const userLock = (params) => { return req("post", "/api/system/userLock", params) }
export const userPwd = (params) => { return req("post", "/api/system/userPwd", params) }
export const delUser = (params) => { return req("get", "/api/system/delUser", params) }
export const getUsers = (params) => { return req("get", "/api/system/getUsers", params) }

// 角色管理
export const roleList = (params) => { return req('get','/api/system/roleList',params)}
export const addRole = (params) => { return req('post','/api/system/addRole',params)}
export const delRole = (params) => { return req('get','/api/system/delRole',params)}
export const roleUsers = (params) => { return req('get','/api/system/roleUsers',params)}
export const setGroups = (params) => { return req('post','/api/system/setGroups',params)}

// 菜单
export const menuList = (params) => { return req('get','/api/system/menuList',params)}
export const authList = (params) => { return req('get','/api/system/authList',params)}

// 权限管理
export const saveAuth = (params) => { return req('post','/api/system/saveAuth',params)}

// 系统设置
export const sysParam = (params) => { return req('get','/api/system/sysParam',params)}
export const wxStart = (params) => { return req('post','/api/system/wxStart',params)}
export const optionList = (params) => { return req('get','/api/system/optionList',params)}
export const setOption = (params) => { return req('post','/api/system/setOption',params)}
export const editRefundPsw = (params) => { return req('post','/api/system/editRefundPsw',params)}

// 问卷调查
export const saveQuestion = (params)  => {return req('post','/api/Investigation/saveQuestion',params)}
export const qusetionList = (params)  => {return req('get','/api/Investigation/qusetionList',params)}
export const saveStatus = (params)  => {return req('post','/api/Investigation/saveStatus',params)}
export const delQuestion = (params)  => {return req('get','/api/Investigation/delQuestion',params)}
// 书记/院长信箱
export const getEmails = (data) => {return req('get','/api/Finance/message',data)}
// 删除信箱内容
export const delEmails = (data) => {return req('post','/api/Finance/delmessage',data)}
// 在线问诊
export const wzpaiban = (data) => {return req('POST','/api/wenzhen/paiban',data)}
export const paibanList = (data) => {return req('GET','/api/wenzhen/paibanList',data)}
export const delPaiban = (data) => {return req('GET','/api/wenzhen/delPaiban',data)}

// 项目预约
export const getInspect = (data) => {return req('GET','/api/yuyue/getInspect',data)}
export const setInspect = (data) => {return req('POST','/api/yuyue/setInspect',data)}
export const getTest = (data) => {return req('GET','/api/yuyue/getTest',data)}
export const setTest = (data) => {return req('POST','/api/yuyue/setTest',data)}

// 核酸列表
export const hsjglist = (data) => {return req('GET','/api/Excel/hslist',data)}
// 删除核酸
export const delHsjg = (params) => { return req('post','/api/hsjc/delHsjg',params)}


// 获取自助开单的订单信息
export const getZzkdOrder = (params) => { return req('post','/api/zzkd/orderlist',params)}
// 更新订单表信息
export const updateZzkdOrder = (params) => { return req('get','/api/zzkd/updateorder',params)}

// 获取项目列表
export const getitem = (params) => { return req('get','/api/zzkd/getitem',params)}
//活动列表  activelist

export const activelist = (params) => { return req('get','/api/active/activelist',params)}
//保存活动
export const saveActive = (params) => { return req('post','/api/active/saveActive',params)}
//删除活动
export const delActive = (params) => { return req('post','/api/active/delActive',params)}
//获取专家信息
export const zjlist = (params) => { return req('get','/api/active/zjlist',params)}



// WEBPACK FOOTER //
// ./src/api/baseset.js